<template>
  <div class="modal_wrapper" :style="{backgroundColor: backgroundColor}">
    <div class="container">
      <div class="modal_container">
        <div class="modal_header">
          <div>
            {{ title }}
          </div>
        </div>
        <div class="modal_body">
          <div class="body">
            <div class="old_login_label_value">
              <div class="label">
                {{ oldLoginLabelValue }}
              </div>
              <div class="detail_label">
                {{ loginLabelValue }}
              </div>
            </div>
            <div class="new_login_label_value">
              <div class="label">
                {{ newLoginLabelValue }}
                <div class="require_items_label">
                  {{ requiredItemLabel }}
                </div>
              </div>
              <input
                type="text"
                id="new_login_label_value"
                v-model="inputNewLoginLabelValue"
              />
            </div>
          </div>
          <div class="modal_buttons">
            <input
              type="button"
              :value="cancelButton"
              class="cancel_button"
              @click="$emit('close')"
            />
            <input
              type="button"
              :value="changeButton"
              class="finish_button"
              @click="showConfirmModal = true"
            />
          </div>
          <div class="modal_window" v-if="showConfirmModal">
            <confirmModalWindow
              :question="changeWord"
              @close="stayClose"
              @ok="changeLoginLabel"
            >
            </confirmModalWindow>
          </div>
          <div class="complete_modal_window" v-if="showCompleteModal">
            <finishModalWindow :question="completeWord" @close="close">
            </finishModalWindow>
          </div>
          <div class="modal_window" v-if="showFailureModal">
            <finishModalWindow :question="failureWord" @close="stayClose">
            </finishModalWindow>
          </div>
          <div class="loading_modal_window" v-if="showloadingModal">
            <loadingModalWindow @close="close"> </loadingModalWindow>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import confirmModalWindow from './confirmModalWindow.vue'
import finishModalWindow from './finishModalWindow.vue'
import loadingModalWindow from './loadingModalWindow.vue'

export default {
  data() {
    return {
      title: 'アプリログイン文言変更',
      oldLoginLabelValue: '現在のアプリログイン文言 :',
      newLoginLabelValue: '新しいアプリログイン文言 :',
      inputNewLoginLabelValue: '',
      changeWord: 'アプリログイン文言を変更しますか？',
      failureWord: '',
      cancelButton: 'キャンセル',
      changeButton: '変更',
      showConfirmModal: false,
      showCompleteModal: false,
      showFailureModal: false,
      showloadingModal: false
    }
  },
  components: {
    confirmModalWindow,
    finishModalWindow,
    loadingModalWindow
  },
  computed: {
    backgroundColor() {
      if (
        this.showCompleteModal === true ||
        this.showConfirmModal === true ||
        this.showFailureModal === true
      ) {
        return ''
      } else {
        return 'rgba(0, 0, 0, .5)'
      }
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    requiredItemLabel() {
      return this.$store.state.error.requiredItemLabel
    },
    loginLabelValue() {
      return this.$store.state.masters.masterData.loginLabelValue
    }
  },
  methods: {
    close(e) {
      this.$emit('close')
    },
    stayClose(e) {
      this.showConfirmModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
      this.showloadingModal = false
    },
    async changeLoginLabel(e) {
      this.showloadingModal = true
      this.showConfirmModal = false
      if (this.inputNewLoginLabelValue === '') {
        this.failureWord =
          this.errorMsg.MSGCRC0334.name + this.errorMsg.MSGCRC0334.value
        this.showFailureModal = true
      } else {
        try {
          await this.$store.dispatch('masters/updateLoginLabelValue', {
            loginLabelValue: this.inputNewLoginLabelValue
          })
          this.completeWord = 'アプリログインの文言を変更しました。'
          this.showCompleteModal = true
        } catch (error) {
          let eventNumber = this.$store.state.error.errorCode.errorCode_430012
          let eventType = 3
          let reason = 'MSGCRC0333'
          if (
            error.response &&
            error.response.data &&
            error.response.data.header &&
            error.response.data.header.message
          ) {
            let errorMessage = error.response.data.header.message
            if (errorMessage === 'MSGCRC0333') {
              this.failureWord =
                this.errorMsg.MSGCRC0333.name +
                this.errorMsg.MSGCRC0333.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else {
              this.failureWord =
                this.errorMsg.MSGCRC0335.name +
                this.errorMsg.MSGCRC0335.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            }
            reason = errorMessage + ' '
            reason += error.response.status
          } else {
            reason = 'MSGCRC0005'
            eventType = 9
            this.failureWord =
              this.errorMsg.MSGCRC0005.name +
              this.errorMsg.MSGCRC0005.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.showFailureModal = true
        }
      }
      this.showloadingModal = false
    }
  }
}
</script>

<style scoped>
.container {
  display: table-cell;
  vertical-align: middle;
}
.modal_container {
  width: 435px;
  height: 320px;
}
.modal_header {
  display: table;
  width: 100%;
}
.modal_header div {
  padding-left: 14px;
  display: table-cell;
  vertical-align: middle;
}
.modal_body {
  height: 276px;
}
.body {
  height: 233px;
  padding-top: 40px;
}
.require_items_label {
  margin-bottom: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/modalWindow/changeLoginLabelModalWindow.vue